import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import {
  HomeComponentQuery,
  WidgetGroupFieldsFragment,
} from "@src/../graphql-types";
import WidgetGroup from "@src/components/widgets/WidgetGroup/WidgetGroup";
import { MaxWidthContainer } from "design-system/src/Components/Grid/Container/MaxWidthContainer";
import { IWidgetGroup } from "@src/interface/Widget";
import { usePageContext } from "@src/components/general/WrapPageElement/PageContext";
import { GATSBY_INTL_DEFAULT_LANG } from "@src/utils/constants";

const Home = (props: { path?: string }) => {
  const { pageContext } = usePageContext();
  const lang = pageContext?.intl.language || GATSBY_INTL_DEFAULT_LANG;

  // TODO use PageQuery instead of StaticQuery to avoid double language filtering
  const { allWidgetGroup } = useStaticQuery<HomeComponentQuery>(graphql`
    query HomeComponent {
      allWidgetGroup(filter: { indentifiant: { eq: "home-rolling-start" } }) {
        nodes {
          ...widgetGroupFields
        }
      }
    }
  `);
  const groupList = allWidgetGroup.nodes.filter((node) => node.lang === lang);

  return (
    <MaxWidthContainer>
      {groupList.map((group: WidgetGroupFieldsFragment) => {
        return (
          <WidgetGroup
            key={group?.indentifiant}
            group={group as IWidgetGroup}
            partialLoad={true}
          />
        );
      })}
    </MaxWidthContainer>
  );
};

export default Home;
